export class RasporedEmitovanja {
  public DatumPocetkaEmitovanja: Date;
  public DatumZavrsetkaEmitovanja: Date;
  public UcestalostId: any;
  public OsnovnaCenaCPP: number;
  public OsnovnaCenaSek: number;
  public Raspored: Array<any>;
  public Trajanje: number;
  public Zauzeto: number;
  public ProgramId: any;
  public Preostalo: number;
  public ProgramNaziv: string;

  public constructor(
    datumPocetkaEmitovanja,
    datumZavrsetkaEmitovanja,
    ucestalostId,
    cenaPoRasporedu,
    osnovnaCenaCPP,
    trajanje,
    zauzeto,
    programId,
    programNaziv
  ) {
    this.DatumPocetkaEmitovanja = datumPocetkaEmitovanja;
    this.DatumZavrsetkaEmitovanja = datumZavrsetkaEmitovanja;
    this.UcestalostId = ucestalostId;
    this.OsnovnaCenaSek = Number(cenaPoRasporedu);
    this.OsnovnaCenaCPP = Number(osnovnaCenaCPP);
    this.Trajanje = trajanje;
    this.ProgramId = programId;
    this.ProgramNaziv = programNaziv;
    this.Zauzeto = zauzeto;
    this.Preostalo = this.Trajanje;
    this.Raspored = new Array<any>();
  }
}



// WEBPACK FOOTER //
// ./src/app/models/raspored-emitovanja.ts